import { useState } from 'react';

import { getContext } from '@/context';
import isAuthorized from '@/utils/user/isAuthorized';
import useMount from './useMount';

const useNormalAuth = () => {
  const [isUserAuthorized, setIsUserAuthorized] = useState(isAuthorized());

  useMount(() => {
    const unSubscribe = getContext().general.auth.subscribe((state) => {
      setIsUserAuthorized(state?.id != null);
    });

    return () => {
      unSubscribe?.();
    };
  });

  return { isAuthorized: isUserAuthorized };
};

export default useNormalAuth;
